/** Several products per workspace — English (structure pinned to fr). */
import type { MultiProductKeys } from './fr';

const multiProductEn: MultiProductKeys = {
  brief: {
    switcherLabel: 'Brief shown',
    primaryBadge: 'Primary',
    primaryOption: '{{name}} (primary)',
    untitled: 'Untitled brief',
    newBrief: 'New brief',
    newBriefTitle: 'New product brief',
    newBriefHint: 'One brief per product. Name it, then analyse its site or describe it.',
    nameLabel: 'Brief name',
    namePlaceholder: 'e.g. My mobile app',
    create: 'Create the brief',
    creating: 'Creating…',
    cancel: 'Cancel',
    created: 'Brief created — now analyse this product’s source.',
    rename: 'Rename',
    renameSave: 'Save the name',
    renamed: 'Brief renamed.',
    setPrimary: 'Make primary',
    primarySet: 'This brief is now the primary one.',
    primaryHint: 'The primary brief is used by default for your daily moves (Today) and your launch kits.',
    delete: 'Delete this brief',
    deleteConfirmTitle: 'Delete this brief?',
    deleteConfirm:
      'The brief “{{name}}”, its versions and its competitor analyses will be deleted. Strategies, offerings and voices already created are kept.',
    deleteConfirmLabel: 'Delete',
    deleted: 'Brief deleted.',
    deletedPromoted: 'Brief deleted. “{{name}}” is now the primary brief.',
    overLimitNotice: 'This brief is above your plan limit: it stays readable and can be deleted, but it is read-only.',
    notAnalysed: 'This brief has not been analysed yet: tell us where this product lives.',
    meterTitle: 'Product briefs included in your plan',
  },
  launchKit: {
    meterTitle: 'Launch kits included in your plan',
    overLimitNotice: 'This kit is above your plan limit: it stays readable and can be deleted, but it is read-only.',
    briefLabel: 'Product brief',
    briefPrimary: '{{name}} (primary)',
    briefNone: 'No brief (fields typed below)',
    directoriesForKit: 'Submission statuses for the kit “{{name}}” (each kit has its own tracker).',
  },
  brandVoice: {
    meterTitle: 'Brand voices included in your plan',
    overLimitNotice: 'Above your plan limit: readable and deletable, no longer retrainable.',
  },
  moves: {
    briefLabel: 'Moves based on the brief',
  },
};

export default multiProductEn;
